import React from 'react';
import { Box, Tooltip } from '@mui/material';
import { colors } from '../../themes/typography';
import { getExperimentIcon, getExperimentTypeText } from '../../utils/experimentBadgeHelpers';

/**
 * Reusable ExperimentBadge component
 * Displays a badge with experiment type icon and tooltip
 */
const ExperimentBadge = ({ experimentType, t }) => {
  if (!experimentType) return null;

  return (
    <Tooltip title={getExperimentTypeText(experimentType, t)} arrow>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: colors.text.secondary,
        cursor: 'help',
      }}>
        {getExperimentIcon(experimentType)}
      </Box>
    </Tooltip>
  );
};

export default ExperimentBadge;